<template>
  <a-layout>
    <a-space style="margin-top: 2px">
      <a-input-search v-model="query['no']" :placeholder="$t('placeholder.ASNOrderNo')" allowClear @pressEnter="getData" @search="getData"/>
      <a-input-search v-model="query['purchase.no']" :placeholder="$t('placeholder.purchaseOrderNo')" allowClear @pressEnter="getData" @search="getData"/>
      <a-select v-model="query['storer.id']" :placeholder="$t('placeholder.storer')" allowClear class="query">
        <a-select-option v-for="d in storerData" :key="d.id">{{d.name}}</a-select-option>
      </a-select>
      <a-input-search v-model="query['item.no']" :placeholder="$t('placeholder.itemNo')" allowClear @pressEnter="getData" @search="getData"/>
      <a-input-search v-model="query['item.name']" :placeholder="$t('placeholder.itemName')" allowClear @pressEnter="getData" @search="getData"/>
      <a-input-search v-model="query['lot.no']" :placeholder="$t('placeholder.lotNo')" allowClear @pressEnter="getData" @search="getData"/>
      <a-date-picker v-model="query.invoiceTimeFilter.start" :disabled-date="disabledStartDate" :placeholder="$t('placeholder.startTime')" allowClear show-today valueFormat="YYYY-MM-DD"/>
      <a-date-picker v-model="query.invoiceTimeFilter.end" :disabled-date="disabledEndDate" :placeholder="$t('placeholder.endTime')" allowClear show-today valueFormat="YYYY-MM-DD"/>
      <vxe-button content="button.query" icon="vxe-icon-search" size="mini" status="primary" @click="getData"/>
      <vxe-button content="button.reset" icon="vxe-icon-undo" size="mini" status="danger" @click="reset"/>
      <vxe-button content="button.expConfirm" size="mini" status="info" @click="exportExcel"/>
    </a-space>
    <vxe-table
      border
      stripe
      round
      show-overflow
      show-header-overflow
      :export-config="{}"
      :keyboard-config="{isArrow: true}"
      :column-config="{resizable: true}"
      :row-config="{isCurrent: true, isHover: true}"
      align="center"
      ref="table"
      :data="data"
      :loading="loading"
      :height="scrollY"
      size="mini"
      :scroll-x="{enabled: true}"
      style="margin-top: 2px">
      <vxe-column fixed="left" sortable title="business.label.index" type="seq" width="50"/>
      <vxe-column field="asnOrder.invoiceTime" sortable title="business.label.invoiceTime" width="170"/>
      <vxe-column field="asnOrder.no" sortable title="business.label.asnOrderNo" width="150"/>
      <vxe-column field="purchaseOrder.no" sortable title="business.label.purchaseOrderNo" width="160"/>
      <vxe-column field="orderType.name" title="business.label.orderType" width="120"/>
      <vxe-column field="asnOrder.operator" title="business.label.maker" width="120"/>
      <vxe-column field="asnOrder.orderStatus" sortable title="business.label.orderStatus" width="100">
        <span slot-scope="{ row }">{{orderStatusData.find(item => item.ordinal === row.asnOrder.orderStatus).name}}</span>
      </vxe-column>
      <vxe-column field="storer.name" title="business.label.storerName" width="120"/>
      <vxe-column field="customer.name" title="business.label.supplierName" width="150"/>
      <vxe-column field="item.no" title="business.label.itemNo" width="80"/>
      <vxe-column field="item.name" title="business.label.itemName" width="150"/>
      <vxe-column field="pack.specification" title="business.label.specification" width="150"/>
      <vxe-column field="pack.factor" title="business.label.factor" width="60"/>
      <vxe-column field="pack.uom" title="business.label.uom" width="60"/>
      <vxe-column field="dosageForm.name" title="business.label.dosageForm" width="120"/>
      <vxe-column field="asnDetail.lotNo" sortable title="business.label.lotNo" width="150"/>
      <vxe-column field="asnDetail.productionDate" title="business.label.productionDate" width="100"/>
      <vxe-column field="asnDetail.validUntil" title="business.label.validUntil" width="100"/>
      <vxe-column field="asnDetail.approvalNo" title="business.label.approvalNo" width="150"/>
      <vxe-column field="asnDetail.manufacturer" title="business.label.manufacturer" width="150"/>
      <vxe-column field="asnDetail.producingArea" title="business.label.producingArea" width="150"/>
      <vxe-column field="asnDetail.quantity" title="business.label.quantity" width="120"/>
      <vxe-column field="asnDetail.receivedQuantity" title="business.label.receivedQuantity" width="160"/>
      <vxe-column field="asnDetail.rejectedQuantity" title="business.label.rejectedQuantity" width="160"/>
      <vxe-column field="asnDetail.acceptedQuantity" title="business.label.acceptedQuantity" width="160"/>
      <vxe-column field="asnDetail.rejectedQuantityOfAcceptance" title="business.label.rejectedQuantityOfAcceptance" width="180"/>
    </vxe-table>
    <vxe-pager :current-page="page" :layouts="['PrevPage', 'JumpNumber', 'NextPage', 'FullJump', 'Sizes', 'Total']" :loading="loading" :page-size="size" :total="contentSize" size="mini" style="height: 24px" @page-change="pageChange"/>
  </a-layout>
</template>
<script>
import { findAll, findEnum } from '@/api/Api'
import moment from 'moment'
import Vue from 'vue'
import { SCREEN_HEIGHT } from '@/store/mutation-types'

export default {
  name: 'AsnDetailQuery',
  data() {
    return {
      data: [],
      orderStatusData: [],
      storerData: [],
      loading: false,
      page: 1,
      size: 20,
      contentSize: 0,
      query: {
        'no': '',
        'purchase.no': '',
        'storer.id': undefined,
        invoiceTimeFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        },
        'item.no': '',
        'item.name': '',
        'item.barcodes': '',
        'lot.no': ''
      },
      scrollY: Vue.ls.get(SCREEN_HEIGHT) * (0.815)// 表格竖向滚动条,减去的数值是页面其他元素的高度
    }
  },
  mounted() {
    findAll('storerFactory', { available: true }).then(res => {
      if (res.success) {
        this.storerData = res.result
      }
    })
    findEnum('OrderStatus').then(res => {
      if (res.success) {
        this.orderStatusData = res.result
      }
    })
  },
  methods: {
    moment,
    disabledStartDate(startValue) {
      const endValue = this.query.invoiceTimeFilter.end
      if (!startValue || !endValue) {
        return false
      }
      return new Date(startValue) > new Date(endValue)
    },
    disabledEndDate(endValue) {
      const startValue = this.query.invoiceTimeFilter.start
      if (!endValue || !startValue) {
        return false
      }
      return new Date(startValue) >= new Date(endValue)
    },
    pageChange({ currentPage, pageSize }) {
      this.page = currentPage
      this.size = pageSize
      this.getData()
    },
    getData() {
      this.loading = true
      const args = Object.assign({}, this.query)
      if (args.invoiceTimeFilter.start === null && args.invoiceTimeFilter.end === null) {
        args.invoiceTimeFilter = null
      }
      findAll('asnDetailFactory', args, this.page, this.size).then(res => {
        if (res.success) {
          this.contentSize = res.contentSize
          this.data = res.result
          setTimeout(() => {
            this.loading = false
          }, 300)
        } else {
          this.loading = false
        }
      })
    },
    exportExcel() {
      this.$refs.table.openExport()
    },
    reset() {
      this.query = {
        'no': '',
        'purchase.no': '',
        'storer.id': undefined,
        invoiceTimeFilter: {
          start: moment().format('YYYY-MM-DD'),
          end: moment().format('YYYY-MM-DD')
        },
        'item.no': '',
        'item.name': '',
        'item.barcodes': '',
        'lot.no': ''
      }
      this.getData()
    }
  }
}
</script>
<style scoped>
.query {
  width: 180px;
}
</style>